import { PASSWORD_STATUS } from "api/interfaces/authInterface.interface";
import { parsePhoneNumber } from "react-phone-number-input/max";
import { checkEmpty } from "./functions";

export interface PasswordValid {
  lowerCase: boolean;
  upperCase: boolean;
  number: boolean;
  specialCharactor: boolean;
}

export const validPassword = (password: string): PASSWORD_STATUS => {
  const passwordLen = password.length;
  const upperCase = /[A-Z]/.test(password);

  if (passwordLen <= 8) {
    return PASSWORD_STATUS.VERY_POOR;
  }

  const lowerCase = /[a-z]/.test(password);
  const num = /\d/.test(password);
  const specialCharactor = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
    password
  );
  const valiadGood = specialCharactor && lowerCase && upperCase && num;

  if (valiadGood && passwordLen >= 14) {
    return PASSWORD_STATUS.EXCELLENT;
  }
  if (valiadGood && passwordLen >= 12) {
    return PASSWORD_STATUS.GOOD;
  }
  if (valiadGood && passwordLen >= 10) {
    return PASSWORD_STATUS.OK;
  }

  return PASSWORD_STATUS.POOR;
};

export const getOnlyNumber = (input: string): string => {
  return /\d/.test(input) ? input : "";
};

export const isPhoneNumberValid = (input: string) => {
  const phone = parsePhoneNumber(input);
  if (
    phone !== undefined &&
    (phone.country === "US" || phone.country === "CA")
  ) {
    return phone.isPossible() && phone.isValid();
  } else {
    return false;
  }
};

export const isUrlValid = (url: string) => {
  if (checkEmpty(url)) {
    return false;
  }
  if (url.includes(" ")) {
    return false;
  }
  if (!url.includes(".")) {
    return false;
  }
  if (
    url.startsWith("http") &&
    !(url.startsWith("http://") || url.startsWith("https://"))
  ) {
    return false;
  }
  if (!url.includes("http")) {
    url = `https://${url}`;
  }
  let [protocol, domain] = url.split("://");
  domain = domain.split("/")[0];
  const regex =
    /(?:[a-zA-Z](?:[a-zA-Z0-9-]*[a-zA-Z])?)(?:\.(?:[a-zA-Z](?:[a-zA-Z0-9-]*[a-zA-Z])?))*$/;
  if (!regex.test(domain)) {
    return false;
  }
  if (checkEmpty(domain)) {
    return false;
  }
  if (domain.startsWith(".") || domain.endsWith(".")) {
    return false;
  }
  if (!domain.includes(".")) {
    return false;
  }
  if (
    (domain.split(".") || []).some(
      (part: string) => part.startsWith("-") || part.endsWith("-")
    )
  ) {
    return false;
  }
  if (domain.length > 253) {
    return false;
  }
  if (
    (domain.split(".") || [])
      .map((item) => item.split("-").flat())
      .some((item) => item.length > 63)
  ) {
    return false;
  }
  if (domain.endsWith(".")) {
    return false;
  }
  //url인 경우
  return true;
};
